import { call, put, takeLatest } from 'redux-saga/effects';

import SDK from '@utils/api';

import { listEhrAppointments } from './actions';

export function* listEhrAppointmentsSaga({ payload }) {
  const leadId = payload?.leadId;

  try {
    yield put(listEhrAppointments.request());
    const api = yield call([SDK, 'getApi']);
    const { body } = yield call([api.leads, 'getLeadEhrAppointments'], {
      id: leadId,
    });
    // The endpoint answers with a panel — { syncState, appointments } — not a
    // bare list. syncState is how the EHR tells an empty history apart from a
    // lead it never looked up.
    const { syncState, appointments } = body ?? {};

    yield put(
      listEhrAppointments.success({
        leadId,
        syncState,
        items: Array.isArray(appointments) ? appointments : [],
      }),
    );
  } catch (error) {
    yield put(
      listEhrAppointments.failure({
        message: error?.response?.body?.message,
        isRetryable: error?.response?.status === 503 || !error?.response,
      }),
    );
  } finally {
    yield put(listEhrAppointments.fulfill());
  }
}

export default function* ehrAppointmentsWatcher() {
  yield takeLatest(listEhrAppointments.TRIGGER, listEhrAppointmentsSaga);
}
